import { LOTTIE_VISUAL } from '../elements/lottie'
import { CONVERSATION_BOX } from '../elements/conversationBox'
import { IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS, BUTTON_SETTINGS_2 } from '../elements/link'
import { LOGO_GARDEN_CONTENT } from './logoGarden'

export const HERO_SIDE_IMAGE_V2 = `
...on heroSideImageV2_Entry {
  ${ LOTTIE_VISUAL }
  ${ CONVERSATION_BOX }
  id
  typeHandle
  anchorId

  ${ IMAGE_MOBILE }
  ${ IMAGE_DESKTOP }

  headingTable {
    ... on headingTable_TableRow {
      heading
    }
  }

  heading {
    html
  }
  description

  headingTextTable {
    heading
    text
  }

  ${ BUTTON }
  ${ BUTTON_SETTINGS }

  button2 {
    url
    title
  }
  ${ BUTTON_SETTINGS_2 }

  ${ LOGO_GARDEN_CONTENT }
}
`